import React, { useEffect, useCallback } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import AuthService from './login'
import TokenManager from '../src/components/TokenManager'

const withAuth = (
  WrappedComponent: React.ComponentType,
  requireAuth: boolean = true,
) => {
  return (props: any) => {
    const location = useLocation()

    const checkAuth = useCallback(async () => {
      if (requireAuth) {
        try {
          const isValid = await TokenManager.checkAndRefreshToken()
          if (!isValid) {
            AuthService.logout()
          }
        } catch (error) {
          Sentry.captureException(error, {
            extra: {
              action: 'checkAuth',
              timestamp: new Date().toISOString(),
            },
            tags: {
              type: 'auth_error',
              method: 'checkAuth',
            },
          })
          AuthService.logout()
        }
      }
    }, [requireAuth])

    useEffect(() => {
      checkAuth()
    }, [checkAuth, location.pathname])

    if (requireAuth && !AuthService.isAuthenticated()) {
      return <Navigate to='/login' state={{ from: location }} replace />
    }

    return <WrappedComponent {...props} />
  }
}

export default withAuth
